<div class="metadata-div">

  <span class="input-field-label" [matTooltip]="label ? label : ''" matTooltipPosition="above">
    <span *ngIf="visibility === 'MT_K'">*</span>{{label}}
  </span>

<!--  <div *ngIf="visibility === 'MT_O'" class="only-read-metadata-data-div">-->
<!--    {{humanvalue}}-->
<!--  </div>-->
  <app-meta-data-onlyread *ngIf="visibility === 'MT_O'" [value]="humanvalue" [title]="label"></app-meta-data-onlyread>

  <mat-form-field *ngIf="visibility === 'MT_K' || visibility === 'MT_M'">
    <mat-select [formControl]="optionFormControl"
                [required]="visibility === 'MT_K'"
                (selectionChange)="onChangeValue($event.value.valueIndex);onChangeHumanValue($event.value.valueView)"
                placeholder="{{'NOT_SELECTED' | translate}}">
      <mat-option *ngFor="let option of options" [value]="option">
        {{option.valueView}}
      </mat-option>
    </mat-select>
    <mat-error *ngIf="optionFormControl.hasError('required')">
      {{'MANDATORY_FIELD' | translate}}
    </mat-error>
  </mat-form-field>

</div>
